module.exports = __webpack_public_path__ + "static/img/bg_water.c098319b.png";